import { SmartFilterSelectionModalComponent } from '../views/smart-filters/modal/smart-filter-selection-modal/smart-filter-selection-modal.component';
import { ModalUtils } from '../utils/modal-utils';
import { Injector, NgZone } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

export class ModalSelectSmartFilter {
  static open(
    ngZone: NgZone,
    ngbModal: NgbModal,
    injector: Injector,
    previouslySelectedIds: string[],
    onClose: (smartFilterIds: string[] | null) => void
  ) {
    ngZone.run(() => {
      const modalRef = ngbModal.open(
        SmartFilterSelectionModalComponent,
        ModalUtils.selectSmartFiltersModalOptions(injector)
      );
      const compInstance = modalRef.componentInstance as SmartFilterSelectionModalComponent;
      compInstance.alreadyAddedSmartFilterIds(previouslySelectedIds);
      modalRef.result.then(onClose).catch(() => {});
    });
  }
}
